import { useEffect } from 'react';
import { blockAutomaticAppReload } from '../services/appUpdateSafety';

export default function useAppUpdateBlocker(blocked: boolean) {
  useEffect(() => {
    if (blocked) return blockAutomaticAppReload();
  }, [blocked]);
}
